import {BreathProcessor} from "../../@Shared/Processors/BreathProcessor.js";
import {zIndexes} from "../../../Utils/UI/ZIndexes.js";
import {ModifyString} from "js-vextensions";
import {observer_mgl} from "mobx-graphlink";
import React, {useEffect} from "react";
import {Button, CheckBox, Column, DropDown, DropDownContent, DropDownTrigger, Row, Text, TextInput} from "react-vcomponents";
import {ScrollView} from "react-vscrollview";
import {ES, RunInAction, RunInAction_Set} from "web-vcore";
import {GetSelectedEngineConfig} from "../../../Server/DB/engineConfigs.js";
import {store} from "../../../Store/index.js";
import {currentBelt, GetBeltDevice_BT} from "../@Shared/BeltInterface.js";
import {BeltGraph} from "./BeltPanel/BeltGraph.js";

export const BeltPanel_TopBarUI = observer_mgl(()=>{
	const uiState = store.main.tools.monitor;
	return (
		<DropDown style={{marginLeft: "auto", marginRight: 5, position: "relative"}}>
			<DropDownTrigger>
				<Button mdIcon="cog" size={32}/>
			</DropDownTrigger>
			<DropDownContent style={{
				zIndex: zIndexes.dropDown, position: "fixed", right: 0,
				top: 32,
				bottom: 0, // bottom:0 = stop at bottom of screen
				background: "rgba(0,0,0,.9)", borderRadius: 5,
			}}>
				<ScrollView style={{height: "100%"}}>
					<Row>
						<Text>Auto-connect device IDs:</Text>
						<Button ml={5} mdIcon="plus" onClick={()=>{
							RunInAction_Set(()=>uiState.autoConnect_beltDevices.push({id: "", enabled: true}));
						}}/>
						<Button ml={5} mdIcon="bluetooth-connect" onClick={async()=>{
							const device = await GetBeltDevice_BT([]); // pass empty auto-connect list; we want to let user pick device
							if (device && device.bleDevice) {
								RunInAction_Set(()=>uiState.autoConnect_beltDevices.push({id: device.bleDevice.deviceId, enabled: true}));
							}
						}}/>
					</Row>
					{uiState.autoConnect_beltDevices.map((id, index)=>{
						return (
							<Row key={index} center>
								<CheckBox title="Enabled" value={uiState.autoConnect_beltDevices[index].enabled} onChange={val=>RunInAction_Set(()=>uiState.autoConnect_beltDevices[index].enabled = val)}/>
								<TextInput ml={5} style={{flex: 1}} value={uiState.autoConnect_beltDevices[index].id} onChange={val=>RunInAction_Set(()=>uiState.autoConnect_beltDevices[index].id = val)}/>
								<Button ml={5} mdIcon="delete" onClick={()=>{
									RunInAction_Set(()=>uiState.autoConnect_beltDevices.RemoveAt(index));
								}}/>
							</Row>
						);
					})}
				</ScrollView>
			</DropDownContent>
		</DropDown>
	);
});

export const BeltPanel = observer_mgl(()=>{
	const uiState = store.main.tools.monitor;
	const engineConfig = GetSelectedEngineConfig();
	const breathCompConfig = engineConfig?.breath ?? null;
	if (breathCompConfig == null) {
		return <div style={{padding: 10}}>Engine-config must be selected (and have breath-comp values defined), to view belt data.</div>;
	}
	// if breath-comp-config changes, recreate the belt's breath-processor
	if (JSON.stringify(breathCompConfig) != JSON.stringify(BeltPanel_breathProcessor.options?.breathCompConfig)) {
		BeltPanel_breathProcessor.Init_LiveSession({breathCompConfig});
	}

	useEffect(()=>{
		return ()=>{
			currentBelt.RemoveConnectRequester("BeltPanel");
		};
	});

	return (
		<Column p={10} style={ES({flex: 1})}>
			<Row center>
				<CheckBox text={ModifyString(currentBelt.beltStatus, m=>[m.startLower_to_upper])}
					value={uiState.belt_monitor}
					onChange={async val=>{
						if (val) {
							if (currentBelt.beltStatus == "connected") return;
							RunInAction("BeltPanel_Connect", ()=>{
								uiState.belt_monitor = true;
								//currentBelt.beltStatus = "connecting";
								currentBelt.AddConnectRequester("BeltPanel");
							});
						} else {
							RunInAction("BeltPanel_Disconnect", ()=>{
								uiState.belt_monitor = false;
								currentBelt.RemoveConnectRequester("BeltPanel");
							});
						}
					}}/>
			</Row>
			<BeltGraph processor={BeltPanel_breathProcessor}/>
		</Column>
	);
});
export const BeltPanel_breathProcessor = new BreathProcessor();

/*OnPopulated(()=>{
	currentBelt.activeProcessors.push(BeltPanel_beltProcessor)
});*/